import participants from './routes'

export default [...participants] as const
